import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminAuthProvider } from "./context/AdminAuth";
import { PortalAuthProvider } from "./context/PortalAuth";
import Landing from "./pages/Landing";
import AdminApp from "./pages/AdminApp";
import AdminCustomerDetail from "./pages/AdminCustomerDetail";
import AdminCatalog from "./pages/AdminCatalog";
import AdminServices from "./pages/AdminServices";
import AdminServiceStats from "./pages/AdminServiceStats";
import PortalLogin from "./pages/PortalLogin";
import PortalVerify from "./pages/PortalVerify";
import CustomerPortal from "./pages/CustomerPortal";
import SiteLayout from "./website/public/SiteLayout";
import Home from "./website/public/Home";
import ServicesPage from "./website/public/ServicesPage";
import OffersPage from "./website/public/OffersPage";
import GalleryPage from "./website/public/GalleryPage";
import ContactPage from "./website/public/ContactPage";
import LegalPage from "./website/public/LegalPage";
import WebsiteAdminApp from "./website/admin/WebsiteAdminApp";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <AdminAuthProvider>
          <PortalAuthProvider>
            <Routes>
              {/* Public business website (CMS-driven) */}
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/leistungen" element={<ServicesPage />} />
                <Route path="/angebote" element={<OffersPage />} />
                <Route path="/galerie" element={<GalleryPage />} />
                <Route path="/kontakt" element={<ContactPage />} />
                <Route path="/rechtliches/:slug" element={<LegalPage />} />
              </Route>
              {/* Website admin (independent from loyalty admin) */}
              <Route path="/website-admin/*" element={<WebsiteAdminApp />} />
              {/* Loyalty system — unchanged */}
              <Route path="/treueprogramm" element={<Landing />} />
              <Route path="/admin" element={<AdminApp />} />
              <Route path="/admin/customers/:id" element={<AdminCustomerDetail />} />
              <Route path="/admin/catalog" element={<AdminCatalog />} />
              <Route path="/admin/services" element={<AdminServices />} />
              <Route path="/admin/statistics" element={<AdminServiceStats />} />
              <Route path="/portal" element={<PortalLogin />} />
              <Route path="/portal/verify" element={<PortalVerify />} />
              <Route path="/portal/home" element={<CustomerPortal />} />
            </Routes>
          </PortalAuthProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
